// extracted by mini-css-extract-plugin
export default {"img-button-wrapper":"autopromo--ioJEJ","img-button-wrapper--centered":"autopromo--1VVZX","autopromo-btn-img":"autopromo--3FyS1"};